// Angular
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// NGRX
import { Store } from '@ngrx/store';

// OLCI
import * as fromRoot from '../../../reducers';
import { constants } from '../../../constants';
import * as tracking from '../../../actions/tracking';

@Component({
    selector: 'app-currency-conversion',
    templateUrl: './modal-currency-conversion.component.html',
    standalone: false
})
export class ModalCurrencyConversionComponent implements OnChanges {
	@Input() public layoutState: string;
	@Input() public bundle: any = null;

	public showMenu: boolean;
	public exitModal = constants.MODAL.EXIT;
	public historyModalState: string;
	public showCurrencyConvertionProgramModal: boolean;

	constructor(private readonly store: Store<fromRoot.AppState>) {
		this.showCurrencyConvertionProgramModal = false;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['layoutState']) {
			const layoutState = changes['layoutState'].currentValue;

			if (layoutState && layoutState.openedModalName === constants.MODAL.CURRENCY_CONVERSION_PROGRAM) {
				this.showCurrencyConvertionProgramModal = true;
				this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: currency convertion program: info dialog opened'));
			} else if (layoutState && layoutState.openedModalName === 'close') {
				this.showCurrencyConvertionProgramModal = false;
			}
		}
	}

	public closeModal(): void {
		this.showCurrencyConvertionProgramModal = false;
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: currency convertion program: user closed info dialog'));
	}
}
